// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table tbody tr td[data-v-25376bb3]:first-child{font-weight:700}.table td[data-v-25376bb3],.table th[data-v-25376bb3]{padding:0;line-height:30px}", ""]);
// Exports
module.exports = exports;
